<h2 class="tags-title hide-large">
    {{ 'filters' | translate }}
    <ng-container *ngIf="selectedTags.size > 1">
        <ui-button type="link" size="no-padding" (click)="clearTags()"><mat-icon svgIcon="close"></mat-icon></ui-button>
    </ng-container>
</h2>
<div class="tags-list">
    <app-search
        class="only-large"
        #searchBar
        placeholder="document.searchTags"
        (onSearch)="onSearch($event)"
    ></app-search>
    @if (documentTags.length) {
        @for (documentTag of documentTags; track documentTag) {
            <label class="tag" [class.active]="selectedTags.has(documentTag)" [title]="documentTag.name">
                <mat-checkbox
                    [color]="'primary'"
                    [checked]="selectedTags.has(documentTag)"
                    (change)="onToggle(documentTag)"
                    [name]="'tag-selector-' + documentTag.id"
                ></mat-checkbox>
                <span class="truncate-text"> {{ documentTag.name }} </span>
            </label>
        }
    } @else {
        <div class="empty">
            <h4 class="empty-state">{{ 'document.noTagsExist' | translate }}</h4>
        </div>
    }
    <div class="manage-tags">
        <a [routerLink]="['/' + pathRoot, 'center', 'manage-tags']">
            <mat-icon class="icon hide-large" svgIcon="settings"></mat-icon>
            <span class="only-large">{{ 'document.manageTags' | translate }}</span>
        </a>
    </div>
</div>
